@if (!isSorting) {
    <mat-icon svgIcon="heroicons_outline:chevron-up-down"></mat-icon>
}
@if (isSorting) {
    @if (isAsc) {
        <mat-icon svgIcon="custom:sort-chevron-down"></mat-icon>
    }
    @if (!isAsc) {
        <mat-icon svgIcon="custom:sort-chevron-up"></mat-icon>
    }
}
